import GastroVisitaProctologicaList from "./pages/GastroVisitaProctologicaList.vue"
import GastroVisitaProctologicaView from "./pages/GastroVisitaProctologicaView.vue"
import GastroVisitaProctologicaEdit from "./pages/GastroVisitaProctologicaEdit.vue"

export default{
    GastroVisitaProctologicaList,
    GastroVisitaProctologicaView,
    GastroVisitaProctologicaEdit,
}